export const experienceData = [
        {
        id: 1,
        company: 'TechFortune',
        jobtitle: 'DSA java',
        startYear: 'Jul 2025',
        endYear: 'Sep 2025'
    },
    {
        id: 2,
        company: 'TechFortune',
        jobtitle: 'React.js',
        startYear: 'Sep 2025',
        endYear: 'Dec 2024'
    },

    // {
    //     id: 3,
    //     company: 'Entersoft Pte Ltd',
    //     jobtitle: 'Smart Contract Auditing ',
    //     startYear: 'Nov 2023',
    //     endYear: 'Dec 2023'
    // },
    //{
       // id: 3,
        //company: 'YHills Edutech Private Limited',
        //jobtitle: 'Artificial Intelligence Intern',
        //startYear: 'Oct 2022',
        //endYear: 'Dec 2022'
   // },
    
    
]